/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_SportInputs */

const en_ui_color_by_sport = /** @type {(inputs: Ui_Color_By_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport color`)
};

const de_ui_color_by_sport = /** @type {(inputs: Ui_Color_By_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sportfarbe`)
};

/**
* | output |
* | --- |
* | "Sport color" |
*
* @param {Ui_Color_By_SportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_sport = /** @type {((inputs?: Ui_Color_By_SportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_SportInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_sport(inputs)
	return de_ui_color_by_sport(inputs)
});